import { Fragment, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { __MANAGEMENT_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import Detail, { GroupForm } from '../../../components/groups/form';
import { CommonGroupCrumbs } from '../constants';
import { toast } from 'react-toastify';

const GroupNewPage = (): React.ReactElement => {
  const { post: insertGroup } = useHttpFetch(`${__MANAGEMENT_API_URL__}/gruppi`);
  const navigate = useNavigate();
  const onSubmit = useCallback(
    (formValues: GroupForm | undefined) => {
      insertGroup({
        nome: formValues?.name,
        note: formValues?.lastUpdate,
        funzioni: formValues?.functionality?.map((operation) => ({
          key: {
            codice: operation.id,
          },
          codiceEnte: operation.institutionCode,
          nome: operation.description,
          entita: operation.entity,
          evento: operation.event,
        })),
        key: {
          codice: formValues?.code,
        },
      }).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/gruppi');
      });
    },
    [insertGroup, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonGroupCrumbs, { name: 'Nuovo Gruppo' }]} />
      <Detail
        onOk={onSubmit}
        insert
        onCancel={() => {
          navigate('/sistema/gruppi');
        }}
      />
    </Fragment>
  );
};

GroupNewPage.displayName = 'Group new page component';

export default GroupNewPage;
